import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0341843c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0341843c&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=0341843c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0341843c')) {
      api.createRecord('0341843c', component.options)
    } else {
      api.reload('0341843c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0341843c&scoped=true", function () {
      api.rerender('0341843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/FormPage/index.vue"
export default component.exports